import { Reducer } from 'redux';
import {
  PHASE_PLAN_SELECTED,
  LOOKAHEAD_OFF_DAY_SELECTED,
  PhasePlanAction,
  LOOKAHEAD_OFF_DAY_CLEAR,
  LOOKAHEAD_LENGTH_SELECTED,
  LOOKAHEAD_LENGTH_CLEAR,
  PHASE_PLAN_HISTOGRAM_TOGGLE,
  PHASE_PLAN_TAG_SELECTED,
  PHASE_PLAN_TAGS_SELECTED,
  PHASE_PLAN_TAGS_CLEARED,
  PHASE_PLAN_FILTER_BY_TRADE,
  LOOKAHEAD_OFF_DAY_BULK_SELECTED
} from '../actions/phaseplan.actions';
import { LOCATION_CHANGE } from 'connected-react-router';

import { isIterable, LookaheadLength } from '../selectors/util.selector';
import { TagType, SelectedTag } from '../models/ TagType';

export interface PhasePlanState {
  readonly selectedPhasePlan: string | null;
  readonly offDays: number[];
  readonly lookaheadLength: LookaheadLength;
  readonly isHistogramOpen: boolean;
  readonly selectedTags: Record<string, SelectedTag>;
}

const defaultState: PhasePlanState = {
  selectedPhasePlan: null,
  offDays: [],
  lookaheadLength: 6,
  isHistogramOpen: false,
  selectedTags: {}
};

export const phasePlanReducer: Reducer<PhasePlanState> = (
  state = defaultState,
  action: PhasePlanAction | any
) => {
  switch (action.type) {
    case PHASE_PLAN_SELECTED:
      return {
        ...state,
        selectedPhasePlan: action.payload.selectedPhasePlan
      };
    case LOOKAHEAD_OFF_DAY_BULK_SELECTED: 
      const selectedDays: number[] = action.payload.selectedDays;

      const _offdays = new Set<number>(selectedDays);
      return {
          ...state,
          offDays: Array.from<number>(_offdays)
      }
    case LOOKAHEAD_OFF_DAY_SELECTED:
      if (!isIterable(state.offDays)) {
        return {
          ...state,
          offDays: []
        };
      }
      const offdays = new Set<number>(state.offDays);
      const selectedDay: number = action.payload.selectedDay;

      if (offdays.has(selectedDay)) {
        offdays.delete(selectedDay);
      } else {
        offdays.add(selectedDay);
      }

      return {
        ...state,
        offDays: Array.from<number>(offdays)
      };
    case LOOKAHEAD_OFF_DAY_CLEAR:
      return {
        ...state,
        offDays: []
      };
    case LOOKAHEAD_LENGTH_SELECTED:
      return {
        ...state,
        lookaheadLength: action.payload.length
      };
    case LOOKAHEAD_LENGTH_CLEAR:
      return {
        ...state,
        lookaheadLength: 6
      };
    case PHASE_PLAN_TAG_SELECTED:
      const selectedTags: Record<string, SelectedTag> = {
        ...state.selectedTags
      };
      if (!!selectedTags[action.payload.tagId]) {
        delete selectedTags[action.payload.tagId];
      } else {
        //selectedTags[action.payload.tagId] = action.payload.tagType
      }

      return {
        ...state,
        selectedTags: { ...selectedTags }
      };

    case PHASE_PLAN_TAGS_SELECTED:
      return {
        ...state,
        selectedTags: { ...action.payload.tags }
      };
    case PHASE_PLAN_TAGS_CLEARED:
      return {
        ...state,
        selectedTags: {}
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        selectedTags: {}
      };
    case PHASE_PLAN_HISTOGRAM_TOGGLE:
      return {
        ...state,
        isHistogramOpen: !state.isHistogramOpen
      };
    case PHASE_PLAN_FILTER_BY_TRADE:
      return {
        ...state,
        tradeFilter: action.payload.trade
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/phaseplan.reducer.ts